import { render, staticRenderFns } from "./PowerGraph.vue?vue&type=template&id=828430d0&scoped=true&"
import script from "./PowerGraph.vue?vue&type=script&lang=js&"
export * from "./PowerGraph.vue?vue&type=script&lang=js&"
import style0 from "./PowerGraph.vue?vue&type=style&index=0&id=828430d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "828430d0",
  null
  
)

export default component.exports